import React from 'react'
import { Box } from '@mui/system'
import { createTheme, responsiveFontSizes, Typography } from '@mui/material'
import { ThemeProvider } from '@emotion/react'
import house from '../assets/house.png'

let theme = createTheme()
theme = responsiveFontSizes(theme)

export default function Header() {
  return (
    <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        flexWrap: 'wrap', 
        margin: '75px auto',
        width: '80%', 
        gap: '25px', 
        '& .house': { 
            width: '100%', 
            maxWidth: 650, 
            height: 'auto' 
        }, 
        '@media screen and (max-width: 599px)': { 
            flexDirection: 'column-reverse', 
            textAlign: 'center' 
        } 
    }}>
        <ThemeProvider theme={theme}>
            <Typography variant='h2' fontWeight='300' flexBasis='50%'>
                <strong>Bienvenue</strong> sur l'application de création de devis pour la conciergerie
            </Typography>
        </ThemeProvider>
        <img src={house} alt='devis maison' className='house' />
    </Box>
  )
}
